import { render, staticRenderFns } from "./editorXls.vue?vue&type=template&id=27785ca2&scoped=true&"
import script from "./editorXls.vue?vue&type=script&lang=js&"
export * from "./editorXls.vue?vue&type=script&lang=js&"
import style0 from "./editorXls.vue?vue&type=style&index=0&lang=less&"
import style1 from "./editorXls.vue?vue&type=style&index=1&id=27785ca2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27785ca2",
  null
  
)

export default component.exports